import { css } from 'styled-components';
var styles = css(["&.nva-img{display:block;}.nva-img__image{max-width:100%;height:auto;}"]);
export default styles;